export const DEFAULT_WEDDING = {
    primary_name: "Lucía",
    secondary_name: "Mateo",
    wedding_date: defaultDateISO(),
    tagline: "Nos casamos",
    message:
        "Después de tantos momentos juntos, queremos celebrar el amor con las personas que más queremos. Será un día único, y nos encantaría compartirlo contigo.",
    template: "classic-elegant",
    cover_image:
        "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=80",
    ceremony: {
        name: "Iglesia de San Miguel",
        address: "Plaza Mayor, 1, Madrid",
        map_url:
            "https://www.google.com/maps/search/?api=1&query=Plaza+Mayor+Madrid",
        time: "12:30",
    },
    party: {
        name: "Finca El Olivar",
        address: "Carretera de la Sierra, km 8, Madrid",
        map_url:
            "https://www.google.com/maps/search/?api=1&query=Finca+El+Olivar+Madrid",
        time: "15:00",
    },
    busEnabled: false,
    busDeparture: "",
    busReturn: "",
    iban: "",
    ibanEnabled: false,
    countdownEnabled: true,
    messageEnabled: true,
};

function defaultDateISO() {
    const d = new Date();
    d.setMonth(d.getMonth() + 6);
    d.setHours(12, 30, 0, 0);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatHumanDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("es-ES", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}

export function googleMapsUrl(query) {
    if (!query) return "";
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        query,
    )}`;
}

export const TEMPLATES = [
    {
        id: "classic-elegant",
        name: "Clásica Elegante",
        description: "Tipografías serif, tonos cálidos y un aire atemporal.",
        swatch: ["#fbf6ee", "#a98248", "#2a2018"],
    },
    {
        id: "minimal-modern",
        name: "Minimal Moderno",
        description: "Limpio, monocromático y de pura tipografía.",
        swatch: ["#ffffff", "#111111", "#ececec"],
    },
];

// Generic Event abstraction — the product is 100% wedding-focused today,
// but internally every persisted event carries an event_type discriminator
// so we can add other event types (baby showers, corporate galas…) later
// without a data migration. The UI does NOT expose this yet.
export const EVENT_TYPES = ["WEDDING"];
export const DEFAULT_EVENT_TYPE = "WEDDING";

export const PLANS = [
    {
        id: "basic",
        name: "Básico",
        price: 29,
        tagline: "Lo esencial, con estilo.",
        features: [
            "URL en nuestro subdominio (webing.app/nombre1-y-nombre2)",
            "Mapas de Google Maps integrados",
            "Cuenta atrás y secciones esenciales",
            "RSVP básico",
            "No incluye dominio propio personalizado",
        ],
    },
    {
        id: "premium",
        name: "Premium",
        price: 49,
        highlighted: true,
        tagline: "Lo que la mayoría elige.",
        features: [
            "Todo lo del plan Básico",
            "Dominio propio personalizado (www.nombres.com)",
            "Galería de fotos para invitados (con límite)",
            "Soporte prioritario",
        ],
    },
    {
        id: "ultra",
        name: "Ultra VIP",
        price: 99,
        tagline: "Sin límites.",
        features: [
            "Todo lo del plan Premium",
            "Espacio ILIMITADO para fotos",
            "Subida de vídeos por parte de los invitados",
            "Soporte VIP por WhatsApp",
        ],
    },
];
